module.exports = __webpack_public_path__ + "img/9.077db466.svg";